import { VGrid } from 'vui';
import './VTable.scss';

export default VGrid('table-col');
